module.exports = __webpack_public_path__ + "static/media/group.1854a58e.png";